export function DartFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M21.12 11.069L3.46 4.158c-.912-.357-1.74.672-1.197 1.486l3.867 5.801a1 1 0 010 1.11l-3.867 5.801c-.543.814.285 1.843 1.196 1.486l17.661-6.91c.848-.332.848-1.532 0-1.863z"
      ></path>
    </svg>
  );
}
